import { Field, FormikContext } from "formik";
import React, { Component } from "react";
import {
  Col,
  Container,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Label,
  Row,
} from "reactstrap";

import { ProviderDetails, ProviderPaymentMethod, User } from "../generated";
import { VrpConsent } from "../generated/models/VRP/VrpConsent";
export interface Props {
  CustomSelectComponent(props: any): void;
  providerDetails: ProviderDetails;
  hidden: boolean;
  selectedTester: User;
  prependPath: string;
  providerId: string;
}
export interface State {
  isPerPaymentChecked: boolean;
  isDayChecked: boolean;
  isWeekChecked: boolean;
  isFortnightChecked: boolean;
  isMonthChecked: boolean;
  isHalfYearChecked: boolean;
  isYearChecked: boolean;
  currentPaymentMethod: ProviderPaymentMethod;
}
const vrpTypeValues = ["Sweeping"];
const amountLimitsStartingAtValues = ["Consent", "Calendar"];
const ukopenBankinkRiskValues = [
  "BillPayment",
  "EcommerceGoods",
  "EcommerceServices",
  "Other",
  "PartyToParty",
];
const amountLimitFortnightStartingAtValues = ["Consent"];
export default class VrpConsentForm extends Component<Props, State> {
  static contextType = FormikContext;
  constructor(props: Props) {
    super(props);
    const supportedPaymentMethods =
      props.providerDetails !== null
        ? Object.keys(this.props.providerDetails.paymentMethods).length > 0
          ? Object.keys(this.props.providerDetails.paymentMethods)
          : ["domestic", "sepa", "inpaymentForm", "vrpConsent"]
        : null;
    const currentPaymentMethod =
      (supportedPaymentMethods?.length ?? 0) > 0
        ? props.providerDetails.paymentMethods[supportedPaymentMethods[0]] || {}
        : null;
    this.state = {
      isPerPaymentChecked: false,
      isDayChecked: false,
      isWeekChecked: false,
      isFortnightChecked: false,
      isMonthChecked: false,
      isHalfYearChecked: false,
      isYearChecked: false,
      currentPaymentMethod: currentPaymentMethod,
    };
  }
  private resolveFormPath(obj: any): any {
    try {
      if (this.props.prependPath.indexOf("[") < 0) {
        return obj[this.props.prependPath];
      }
    } catch {
      return null;
    }
  }
  getPropertyAccess(data: VrpConsent, propertyPath: string) {
    const lastIndexOfDot = propertyPath.lastIndexOf(".");
    if (lastIndexOfDot < 0) {
      return {
        obj: data,
        propertyName: propertyPath,
      };
    }

    const propertyNames = propertyPath.substring(0, lastIndexOfDot).split(".");
    let currentObj = data as any;
    for (let propertyName of propertyNames) {
      if (!currentObj[propertyName]) {
        currentObj[propertyName] = {};
      }
      currentObj = currentObj[propertyName];
    }

    return {
      obj: currentObj,
      propertyName: propertyPath.substring(lastIndexOfDot + 1),
    };
  }
  getPropertyValue(data: VrpConsent, propertyPath: string) {
    const propertyAccess = this.getPropertyAccess(data, propertyPath);
    return propertyAccess.obj[propertyAccess.propertyName];
  }
  validateIfCheckboxesAreChecked() {
    return (
      !this.state.isDayChecked &&
      !this.state.isWeekChecked &&
      !this.state.isFortnightChecked &&
      !this.state.isMonthChecked &&
      !this.state.isHalfYearChecked &&
      !this.state.isYearChecked
    );
  }
  formatDate(inputDate: Date) {
    let date, month, year;

    date = inputDate.getDate();
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();

    date = date.toString().padStart(2, "0");

    month = month.toString().padStart(2, "0");

    return `${month}/${date}/${year}`;
  }
  isValidFromLowerThanCurrentDate(validFrom: Date) {
    const date = new Date();
    const formattedCurrent = this.formatDate(date);

    return validFrom.getTime() < new Date(formattedCurrent).getTime();
  }

  isValidFromInvalid(validFrom: Date) {
    return this.isValidFromLowerThanCurrentDate(validFrom);
  }
  isValidToLowerThanCurrentDate(validTo: Date) {
    const date = new Date();
    const formattedCurrent = this.formatDate(date);
    return validTo.getTime() < new Date(formattedCurrent).getTime();
  }
  isValidToGreaterThan1Month1Day(validTo: Date) {
    const date = new Date();
    const maxAllowedDate = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate() + 1
    );
    return validTo.getTime() > maxAllowedDate.getTime();
  }
  isValidToLowerThanValidFrom(validFrom: Date, validTo: Date) {
    return validTo.getTime() < validFrom.getTime();
  }
  isValidToInvalid(validFrom: Date, validTo: Date) {
    return (
      this.isValidToLowerThanCurrentDate(validTo) ||
      this.isValidToLowerThanValidFrom(validFrom, validTo) ||
      this.isValidToGreaterThan1Month1Day(validTo)
    );
  }

  validateField(fieldPath: string, values: VrpConsent) {
    return (value: string): string | undefined => {
      if (this.props.hidden) {
        return undefined;
      }
      const schema =
        (this.state.currentPaymentMethod?.properties || {})[fieldPath] || {};
      if (fieldPath.endsWith(".value")) {
        schema.greaterThan = 0;
        schema.required = true;
      }

      if (fieldPath.endsWith(".currency")) {
        schema.possibleValues = ["GBP"];
        schema.greaterThan = 0;
        schema.required = true;
      }

      if (fieldPath.endsWith(".name")) {
        schema.maxLength = 350;
      }
      if (fieldPath.endsWith(".referenceInformation")) {
        schema.maxLength = 18;
      }
      if (fieldPath.endsWith(".creditor.accountNumber")) {
        schema.maxLength = 8;
        schema.required = true;
      }
      if (fieldPath.endsWith(".creditor.sortCode")) schema.required = true;
      if (
        fieldPath === "validFrom" &&
        this.isValidFromInvalid(new Date(values?.validFrom))
      ) {
        return "Error validFrom TODO";
      }
      if (
        fieldPath === "validTo" &&
        this.isValidToInvalid(
          new Date(values?.validFrom),
          new Date(values?.validTo)
        )
      ) {
        return "Error validTo TODO";
      }

      if (
        schema.required === true &&
        ((typeof value === "string" && (value?.trim()?.length ?? 0) === 0) ||
          (typeof value !== "string" && isNaN(Number(value))))
      ) {
        return "This field is required";
      }

      if (
        schema.minLength !== undefined &&
        (value?.trim()?.length ?? 0) < schema.minLength
      ) {
        return `Minimum length is ${schema.minLength}`;
      }

      if (
        schema.maxLength !== undefined &&
        (value?.trim()?.length ?? 0) > schema.maxLength
      ) {
        return `Maximum length is ${schema.maxLength}`;
      }

      if (
        Array.isArray(schema.possibleValues) &&
        !schema.possibleValues.includes(value?.trim())
      ) {
        return `Possible values are: ${schema.possibleValues.join(", ")}`;
      }

      if (
        schema.greaterThan !== undefined &&
        Number(value) <= schema.greaterThan
      ) {
        return `Value must be greater than ${schema.greaterThan}`;
      }

      if (
        (fieldPath === "amountLimits.perPayment" ||
          fieldPath === "amountLimits.day" ||
          fieldPath === "amountLimits.week" ||
          fieldPath === "amountLimits.fortnight" ||
          fieldPath === "amountLimits.month" ||
          fieldPath === "amountLimits.halfYear" ||
          fieldPath === "amountLimits.year") &&
        this.validateIfCheckboxesAreChecked()
      ) {
        return "todo one checkbox";
      }

      return undefined;
    };
  }

  render() {
    console.log(this.context.values);
    const errors = this.resolveFormPath(this.context.errors) || {};
    const touched = this.resolveFormPath(this.context.touched) || {};
    const values = (this.resolveFormPath(this.context.values) ||
      {}) as VrpConsent;

    return (
      <Container hidden={!!this.props.hidden}>
        <Row>
          <Col xs={12} md={6}>
            <h4>Basics</h4>
            <Row>
              <Col xs={4}>
                <FormGroup>
                  <Label htmlFor={this.props.prependPath + ".vrpType"}>
                    VRP Type
                  </Label>
                  <Field
                    name={this.props.prependPath + ".vrpType"}
                    as={this.props.CustomSelectComponent}
                  >
                    {Object.values(vrpTypeValues).map((vrpType) => (
                      <option key={vrpType} value={vrpType}>
                        {vrpType}
                      </option>
                    ))}
                  </Field>
                </FormGroup>
              </Col>
              <Col xs={4}>
                <FormGroup>
                  <Label htmlFor={this.props.prependPath + ".validFrom"}>
                    Valid From
                  </Label>
                  <Input
                    name={this.props.prependPath + ".validFrom"}
                    type="date"
                    tag={Field}
                    validate={this.validateField("validFrom", values)}
                  />
                  {this.isValidFromInvalid(new Date(values.validFrom)) ? (
                    <FormText>
                      <div className="text-danger">
                        Field must be in the future
                      </div>
                    </FormText>
                  ) : (
                    <FormText color="muted">
                      Field must not be earlier than current date
                    </FormText>
                  )}
                </FormGroup>
              </Col>
              <Col xs={4}>
                <FormGroup>
                  <Label htmlFor={this.props.prependPath + ".validTo"}>
                    Valid To
                  </Label>
                  <Input
                    name={this.props.prependPath + ".validTo"}
                    required
                    tag={Field}
                    validate={this.validateField("validTo", values)}
                    type="date"
                  />

                  {this.isValidToInvalid(
                    new Date(values.validFrom),
                    new Date(values.validTo)
                  ) ? (
                    <FormText>
                      <div className="text-danger">
                        <p>
                          Field must be greater than Valid From field and must
                          be in the future and should be earlier than 1 month
                          and 1 day{" "}
                        </p>
                      </div>
                    </FormText>
                  ) : (
                    <FormText color="muted">
                      Field must not be in the past
                    </FormText>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <FormGroup>
                  <Label
                    htmlFor={
                      this.props.prependPath +
                      ".paymentDetails.referenceInformation"
                    }
                  >
                    Message
                  </Label>
                  <Input
                    name={
                      this.props.prependPath +
                      ".paymentDetails.referenceInformation"
                    }
                    placeholder="Invoice ID148773"
                    tag={Field}
                    validate={this.validateField(
                      "paymentDetails.referenceInformation",
                      values
                    )}
                    valid={
                      !errors.paymentDetails?.referenceInformation &&
                      touched.paymentDetails?.referenceInformation
                    }
                    invalid={
                      errors.paymentDetails?.referenceInformation &&
                      touched.paymentDetails?.referenceInformation
                    }
                  />
                  <FormText color="muted">Message to recipient</FormText>
                  {errors.paymentDetails?.referenceInformation &&
                    touched.paymentDetails?.referenceInformation && (
                      <FormFeedback>
                        {errors.paymentDetails?.referenceInformation}
                      </FormFeedback>
                    )}
                </FormGroup>
              </Col>
              <Col xs={6} style={{ marginTop: 30 }}>
                <FormGroup>
                  <Label
                    htmlFor={
                      this.props.prependPath +
                      ".consentContext.queryDebtorAccount"
                    }
                  >
                    <Input
                      name={
                        this.props.prependPath +
                        ".consentContext.queryDebtorAccount"
                      }
                      tag={Field}
                      type="checkbox"
                    />{" "}
                    Query debtor account
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <h4>Amount Limits</h4>
            </Row>
            <Row>
              <Col xs={12}>
                <FormGroup>
                  <Label
                    htmlFor={
                      this.props.prependPath + ".amountLimits.perPayment"
                    }
                  >
                    <Input
                      name={this.props.prependPath + ".amountLimits.perPayment"}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.perPayment",
                        values
                      )}
                      required
                      type="checkbox"
                      checked={this.state.isPerPaymentChecked}
                      onChange={() =>
                        this.setState({
                          isPerPaymentChecked: !this.state.isPerPaymentChecked,
                        })
                      }
                    />{" "}
                    Per payment
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            {this.state.isPerPaymentChecked && (
              <Row style={{ marginLeft: 80 }}>
                <Col xs={6}>
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.perPayment.amount.value"
                      }
                    >
                      Amount
                    </Label>
                    <Input
                      name={
                        this.props.prependPath +
                        ".amountLimits.perPayment.amount.value"
                      }
                      placeholder="1"
                      required={this.state.isPerPaymentChecked}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.perPayment.amount.value",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.perPayment?.amount?.value &&
                        touched.amountLimits?.perPayment?.amount?.value
                      }
                      invalid={
                        errors.amountLimits?.perPayment?.amount?.value &&
                        touched.amountLimits?.perPayment?.amount?.value
                      }
                    />
                    {errors.amountLimits?.perPayment?.amount?.value &&
                      touched.amountLimits?.perPayment?.amount?.value && (
                        <FormFeedback>
                          {errors.amountLimits?.perPayment?.amount?.value}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
                <Col xs={6}>
                  {" "}
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.perPayment.amount.currency"
                      }
                    >
                      Currency
                    </Label>
                    <Input
                      name={
                        this.props.prependPath +
                        ".amountLimits.perPayment.amount.currency"
                      }
                      placeholder="GBP"
                      required={this.state.isPerPaymentChecked}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.perPayment.amount.currency",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.perPayment?.amount?.currency &&
                        touched.amountLimits?.perPayment?.amount?.currency
                      }
                      invalid={
                        errors.amountLimits?.perPayment?.amount?.currency &&
                        touched.amountLimits?.perPayment?.amount?.currency
                      }
                    />
                    {errors.amountLimits?.perPayment?.amount?.currency &&
                      touched.amountLimits?.perPayment?.amount?.currency && (
                        <FormFeedback>
                          {errors.amountLimits?.perPayment?.amount?.currency}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12}>
                <FormGroup>
                  <Label htmlFor={this.props.prependPath + ".amountLimits.day"}>
                    <Input
                      name={this.props.prependPath + ".amountLimits.day"}
                      tag={Field}
                      validate={this.validateField("amountLimits.day", values)}
                      type="checkbox"
                      checked={this.state.isDayChecked}
                      onChange={() =>
                        this.setState({
                          isDayChecked: !this.state.isDayChecked,
                        })
                      }
                    />{" "}
                    Day
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            {this.state.isDayChecked && (
              <Row style={{ marginLeft: 80 }}>
                <Col xs={4}>
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.day.amount.value"
                      }
                    >
                      Amount
                    </Label>
                    <Input
                      name={
                        this.props.prependPath +
                        ".amountLimits.day.amount.value"
                      }
                      placeholder="1"
                      required={this.state.isDayChecked}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.day.amount.value",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.day?.amount?.value &&
                        touched.amountLimits?.day?.amount?.value
                      }
                      invalid={
                        errors.amountLimits?.day?.amount?.value &&
                        touched.amountLimits?.day?.amount?.value
                      }
                    />
                    {errors.amountLimits?.day?.amount?.value &&
                      touched.amountLimits?.day?.amount?.value && (
                        <FormFeedback>
                          {errors.amountLimits?.day?.amount?.value}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
                <Col xs={4}>
                  {" "}
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.day.amount.currency"
                      }
                    >
                      Currency
                    </Label>
                    <Input
                      name={
                        this.props.prependPath +
                        ".amountLimits.day.amount.currency"
                      }
                      placeholder="GBP"
                      required={this.state.isDayChecked}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.day.amount.currency",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.day?.amount?.currency &&
                        touched.amountLimits?.day?.amount?.currency
                      }
                      invalid={
                        errors.amountLimits?.day?.amount?.currency &&
                        touched.amountLimits?.day?.amount?.currency
                      }
                    />
                    {errors.amountLimits?.day?.amount?.currency &&
                      touched.amountLimits?.day?.amount?.currency && (
                        <FormFeedback>
                          {errors.amountLimits?.day?.amount?.currency}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
                <Col xs={4}>
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath + ".amountLimits.day.startingAt"
                      }
                    >
                      Starting At
                    </Label>
                    <Field
                      name=".amountLimits.day.startingAt"
                      required={this.state.isDayChecked}
                      as={this.props.CustomSelectComponent}
                      validate={this.validateField(
                        "amountLimits.day.startingAt",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.day?.startingAt &&
                        touched.amountLimits?.day?.startingAt
                      }
                      invalid={
                        errors.amountLimits?.day?.startingAt &&
                        touched.amountLimits?.day?.startingAt
                      }
                    >
                      <option value=""></option>
                      {Object.values(amountLimitsStartingAtValues).map(
                        (amountLimitValue) => (
                          <option
                            key={amountLimitValue}
                            value={amountLimitValue}
                          >
                            {amountLimitValue}
                          </option>
                        )
                      )}
                    </Field>
                    {errors.amountLimits?.day?.startingAt &&
                      touched.amountLimits?.day?.startingAt && (
                        <FormFeedback>
                          {errors.amountLimits?.day?.startingAt}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12}>
                <FormGroup>
                  <Label
                    htmlFor={this.props.prependPath + ".amountLimits.week"}
                  >
                    <Input
                      name={this.props.prependPath + ".amountLimits.week"}
                      tag={Field}
                      validate={this.validateField("amountLimits.week", values)}
                      type="checkbox"
                      checked={this.state.isWeekChecked}
                      onChange={() =>
                        this.setState({
                          isWeekChecked: !this.state.isWeekChecked,
                        })
                      }
                    />{" "}
                    Week
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            {this.state.isWeekChecked && (
              <Row style={{ marginLeft: 80 }}>
                <Col xs={4}>
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.week.amount.value"
                      }
                    >
                      Amount
                    </Label>
                    <Input
                      name={
                        this.props.prependPath +
                        ".amountLimits.week.amount.value"
                      }
                      placeholder="1"
                      required={this.state.isWeekChecked}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.week.amount.value",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.week?.amount?.value &&
                        touched.amountLimits?.week?.amount?.value
                      }
                      invalid={
                        errors.amountLimits?.week?.amount?.value &&
                        touched.amountLimits?.week?.amount?.value
                      }
                    />
                    {errors.amountLimits?.week?.amount?.value &&
                      touched.amountLimits?.week?.amount?.value && (
                        <FormFeedback>
                          {errors.amountLimits?.week?.amount?.value}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
                <Col xs={4}>
                  {" "}
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.week.amount.currency"
                      }
                    >
                      Currency
                    </Label>
                    <Input
                      name={
                        this.props.prependPath +
                        ".amountLimits.week.amount.currency"
                      }
                      placeholder="GBP"
                      required={this.state.isWeekChecked}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.week.amount.currency",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.week?.amount?.currency &&
                        touched.amountLimits?.week?.amount?.currency
                      }
                      invalid={
                        errors.amountLimits?.week?.amount?.currency &&
                        touched.amountLimits?.week?.amount?.currency
                      }
                    />
                    {errors.amountLimits?.week?.amount?.currency &&
                      touched.amountLimits?.week?.amount?.currency && (
                        <FormFeedback>
                          {errors.amountLimits?.week?.amount?.currency}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
                <Col xs={4}>
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath + ".amountLimits.week.startingAt"
                      }
                    >
                      Starting At
                    </Label>
                    <Field
                      name=".amountLimits.week.startingAt"
                      required={this.state.isWeekChecked}
                      as={this.props.CustomSelectComponent}
                      validate={this.validateField(
                        "amountLimits.week.startingAt",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.week?.startingAt &&
                        touched.amountLimits?.week?.startingAt
                      }
                      invalid={
                        errors.amountLimits?.week?.startingAt &&
                        touched.touched.amountLimits?.week?.startingAt
                      }
                    >
                      <option value=""></option>
                      {Object.values(amountLimitsStartingAtValues).map(
                        (amountLimitValue) => (
                          <option
                            key={amountLimitValue}
                            value={amountLimitValue}
                          >
                            {amountLimitValue}
                          </option>
                        )
                      )}
                    </Field>
                    {errors.amountLimits?.week?.startingAt &&
                      touched.amountLimits?.week?.startingAt && (
                        <FormFeedback>
                          {errors.amountLimits?.week?.startingAt}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12}>
                <FormGroup>
                  <Label
                    htmlFor={this.props.prependPath + ".amountLimits.fortnight"}
                  >
                    <Input
                      name={this.props.prependPath + ".amountLimits.fortnight"}
                      validate={this.validateField(
                        "amountLimits.fortnight",
                        values
                      )}
                      tag={Field}
                      type="checkbox"
                      checked={this.state.isFortnightChecked}
                      onChange={() =>
                        this.setState({
                          isFortnightChecked: !this.state.isFortnightChecked,
                        })
                      }
                    />{" "}
                    Fortnight
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            {this.state.isFortnightChecked && (
              <Row style={{ marginLeft: 80 }}>
                <Col xs={4}>
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.fortnight.amount.value"
                      }
                    >
                      Amount
                    </Label>
                    <Input
                      name={
                        this.props.prependPath +
                        ".amountLimits.fortnight.amount.value"
                      }
                      placeholder="1"
                      required={this.state.isFortnightChecked}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.fortnight.amount.value",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.fortnight?.amount?.value &&
                        touched.amountLimits?.fortnight?.amount?.value
                      }
                      invalid={
                        errors.amountLimits?.fortnight?.amount?.value &&
                        touched.amountLimits?.fortnight?.amount?.value
                      }
                    />
                    {errors.amountLimits?.fortnight?.amount?.value &&
                      touched.amountLimits?.fortnight?.amount?.value && (
                        <FormFeedback>
                          {errors.amountLimits?.fortnight?.amount?.value}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
                <Col xs={4}>
                  {" "}
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.fortnight.amount.currency"
                      }
                    >
                      Currency
                    </Label>
                    <Input
                      name={
                        this.props.prependPath +
                        ".amountLimits.fortnight.amount.currency"
                      }
                      placeholder="GBP"
                      required={this.state.isFortnightChecked}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.fortnight.amount.currency",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.fortnight?.amount?.currency &&
                        touched.amountLimits?.fortnight?.amount?.currency
                      }
                      invalid={
                        errors.amountLimits?.fortnight?.amount?.currency &&
                        touched.amountLimits?.fortnight?.amount?.currency
                      }
                    />
                    {errors.amountLimits?.fortnight?.amount?.currency &&
                      touched.amountLimits?.fortnight?.amount?.currency && (
                        <FormFeedback>
                          {errors.amountLimits?.fortnight?.amount?.currency}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
                <Col xs={4}>
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.fortnight.startingAt"
                      }
                    >
                      Starting At
                    </Label>
                    <Field
                      name=".amountLimits.fortnight.startingAt"
                      required={this.state.isFortnightChecked}
                      as={this.props.CustomSelectComponent}
                      validate={this.validateField(
                        "amountLimits.fortnight.startingAt",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.fortnight?.startingAt &&
                        touched.amountLimits?.fortnight?.startingAt
                      }
                      invalid={
                        errors.amountLimits?.fortnight?.startingAt &&
                        touched.amountLimits?.fortnight?.startingAt
                      }
                    >
                      {Object.values(amountLimitFortnightStartingAtValues).map(
                        (amountLimitValue) => (
                          <option
                            key={amountLimitValue}
                            value={amountLimitValue}
                          >
                            {amountLimitValue}
                          </option>
                        )
                      )}
                    </Field>
                    {errors.amountLimits?.fortnight?.startingAt &&
                      touched.amountLimits?.fortnight?.startingAt && (
                        <FormFeedback>
                          {errors.amountLimits?.fortnight?.startingAt}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12}>
                <FormGroup>
                  <Label
                    htmlFor={this.props.prependPath + ".amountLimits.month"}
                  >
                    <Input
                      name={this.props.prependPath + ".amountLimits.month"}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.month",
                        values
                      )}
                      type="checkbox"
                      checked={this.state.isMonthChecked}
                      onChange={() =>
                        this.setState({
                          isMonthChecked: !this.state.isMonthChecked,
                        })
                      }
                    />{" "}
                    Month
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            {this.state.isMonthChecked && (
              <Row style={{ marginLeft: 80 }}>
                <Col xs={4}>
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.month.amount.value"
                      }
                    >
                      Amount
                    </Label>
                    <Input
                      name={
                        this.props.prependPath +
                        ".amountLimits.month.amount.value"
                      }
                      placeholder="1"
                      required={this.state.isMonthChecked}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.month.amount.value",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.month?.amount?.value &&
                        touched.amountLimits?.month?.amount?.value
                      }
                      invalid={
                        errors.amountLimits?.month?.amount?.value &&
                        touched.amountLimits?.month?.amount?.value
                      }
                    />
                    {errors.amountLimits?.month?.amount?.value &&
                      touched.amountLimits?.month?.amount?.value && (
                        <FormFeedback>
                          {errors.amountLimits?.month?.amount?.value}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
                <Col xs={4}>
                  {" "}
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.month.amount.currency"
                      }
                    >
                      Currency
                    </Label>
                    <Input
                      name={
                        this.props.prependPath +
                        ".amountLimits.month.amount.currency"
                      }
                      placeholder="GBP"
                      required={this.state.isMonthChecked}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.month.amount.currency",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.month?.amount?.currency &&
                        touched.amountLimits?.month?.amount?.currency
                      }
                      invalid={
                        errors.amountLimits?.month?.amount?.currency &&
                        touched.amountLimits?.month?.amount?.currency
                      }
                    />
                    {errors.amountLimits?.month?.amount?.currency &&
                      touched.amountLimits?.month?.amount?.currency && (
                        <FormFeedback>
                          {errors.amountLimits?.month?.amount?.currency}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
                <Col xs={4}>
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.month.startingAt"
                      }
                    >
                      Starting At
                    </Label>
                    <Field
                      name=".amountLimits.month.startingAt"
                      required={this.state.isMonthChecked}
                      as={this.props.CustomSelectComponent}
                      validate={this.validateField(
                        "amountLimits.month.startingAt",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.month?.startingAt &&
                        touched.amountLimits?.month?.startingAt
                      }
                      invalid={
                        errors.amountLimits?.month?.startingAt &&
                        touched.amountLimits?.month?.startingAt
                      }
                    >
                      <option value=""></option>
                      {Object.values(amountLimitsStartingAtValues).map(
                        (amountLimitValue) => (
                          <option
                            key={amountLimitValue}
                            value={amountLimitValue}
                          >
                            {amountLimitValue}
                          </option>
                        )
                      )}
                    </Field>

                    {errors.amountLimits?.month?.startingAt &&
                      touched.amountLimits?.month?.startingAt && (
                        <FormFeedback>
                          {errors.amountLimits?.month?.startingAt}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12}>
                <FormGroup>
                  <Label
                    htmlFor={this.props.prependPath + ".amountLimits.halfYear"}
                  >
                    <Input
                      name={this.props.prependPath + ".amountLimits.halfYear"}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.halfYear",
                        values
                      )}
                      type="checkbox"
                      checked={this.state.isHalfYearChecked}
                      onChange={() =>
                        this.setState({
                          isHalfYearChecked: !this.state.isHalfYearChecked,
                        })
                      }
                    />{" "}
                    Half year
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            {this.state.isHalfYearChecked && (
              <Row style={{ marginLeft: 80 }}>
                <Col xs={4}>
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.halfYear.amount.value"
                      }
                    >
                      Amount
                    </Label>
                    <Input
                      name={
                        this.props.prependPath +
                        ".amountLimits.halfYear.amount.value"
                      }
                      placeholder="1"
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.halfYear.amount.value",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.halfYear?.amount?.value &&
                        touched.amountLimits?.halfYear?.amount?.value
                      }
                      invalid={
                        errors.amountLimits?.halfYear?.amount?.value &&
                        touched.amountLimits?.halfYear?.amount?.value
                      }
                    />
                    {errors.amountLimits?.halfYear?.amount?.value &&
                      touched.amountLimits?.halfYear?.amount?.value && (
                        <FormFeedback>
                          {errors.amountLimits?.halfYear?.amount?.value}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
                <Col xs={4}>
                  {" "}
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.halfYear.amount.currency"
                      }
                    >
                      Currency
                    </Label>
                    <Input
                      name={
                        this.props.prependPath +
                        ".amountLimits.halfYear.amount.currency"
                      }
                      placeholder="GBP"
                      required={this.state.isHalfYearChecked}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.halfYear.amount.currency",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.halfYear?.amount?.currency &&
                        touched.amountLimits?.halfYear?.amount?.currency
                      }
                      invalid={
                        errors.amountLimits?.halfYear?.amount?.currency &&
                        touched.amountLimits?.halfYear?.amount?.currency
                      }
                    />
                    {errors.amountLimits?.halfYear?.amount?.currency &&
                      touched.amountLimits?.halfYear?.amount?.currency && (
                        <FormFeedback>
                          {errors.amountLimits?.halfYear?.amount?.currency}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
                <Col xs={4}>
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.halfYear.startingAt"
                      }
                    >
                      Starting At
                    </Label>
                    <Field
                      name=".amountLimits.halfYear.startingAt"
                      required={this.state.isHalfYearChecked}
                      as={this.props.CustomSelectComponent}
                      validate={this.validateField(
                        "amountLimits.halfYear.startingAt",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.halfYear?.startingAt &&
                        touched.amountLimits?.halfYear?.startingAt
                      }
                      invalid={
                        errors.amountLimits?.halfYear?.startingAt &&
                        touched.amountLimits?.halfYear?.startingAt
                      }
                    >
                      <option value=""></option>
                      {Object.values(amountLimitsStartingAtValues).map(
                        (amountLimitValue) => (
                          <option
                            key={amountLimitValue}
                            value={amountLimitValue}
                          >
                            {amountLimitValue}
                          </option>
                        )
                      )}
                    </Field>
                    {errors.amountLimits?.halfYear?.startingAt &&
                      touched.amountLimits?.halfYear?.startingAt && (
                        <FormFeedback>
                          {errors.amountLimits?.halfYear?.startingAt}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
              </Row>
            )}

            <Row>
              <Col xs={12}>
                <FormGroup>
                  <Label
                    htmlFor={this.props.prependPath + ".amountLimits.year"}
                  >
                    <Input
                      name={this.props.prependPath + ".amountLimits.year"}
                      tag={Field}
                      validate={this.validateField("amountLimits.year", values)}
                      type="checkbox"
                      checked={this.state.isYearChecked}
                      onChange={() =>
                        this.setState({
                          isYearChecked: !this.state.isYearChecked,
                        })
                      }
                    />{" "}
                    Year
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            {this.state.isYearChecked && (
              <Row style={{ marginLeft: 80 }}>
                <Col xs={4}>
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.year.amount.value"
                      }
                    >
                      Amount
                    </Label>
                    <Input
                      name={
                        this.props.prependPath +
                        ".amountLimits.year.amount.value"
                      }
                      placeholder="1"
                      required={this.state.isYearChecked}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.year.amount.value",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.year?.amount?.value &&
                        touched.amountLimits?.year?.amount?.value
                      }
                      invalid={
                        errors.amountLimits?.year?.amount?.value &&
                        touched.amountLimits?.year?.amount?.value
                      }
                    />
                    {errors.amountLimits?.year?.amount?.value &&
                      touched.amountLimits?.year?.amount?.value && (
                        <FormFeedback>
                          {errors.amountLimits?.year?.amount?.value}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
                <Col xs={4}>
                  {" "}
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath +
                        ".amountLimits.year.amount.currency"
                      }
                    >
                      Currency
                    </Label>
                    <Input
                      name={
                        this.props.prependPath +
                        ".amountLimits.year.amount.currency"
                      }
                      placeholder="GBP"
                      required={this.state.isYearChecked}
                      tag={Field}
                      validate={this.validateField(
                        "amountLimits.year.amount.currency",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.year?.amount?.currency &&
                        touched.amountLimits?.year?.amount?.currency
                      }
                      invalid={
                        errors.amountLimits?.year?.amount?.currency &&
                        touched.amountLimits?.year?.amount?.currency
                      }
                    />
                    {errors.amountLimits?.year?.amount?.currency &&
                      touched.amountLimits?.year?.amount?.currency && (
                        <FormFeedback>
                          {errors.amountLimits?.year?.amount?.currency}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
                <Col xs={4}>
                  <FormGroup>
                    <Label
                      htmlFor={
                        this.props.prependPath + ".amountLimits.year.startingAt"
                      }
                    >
                      Starting At
                    </Label>
                    <Field
                      name=".amountLimits.year.startingAt"
                      required={this.state.isYearChecked}
                      as={this.props.CustomSelectComponent}
                      validate={this.validateField(
                        "amountLimits.year.startingAt",
                        values
                      )}
                      valid={
                        !errors.amountLimits?.year?.startingAt &&
                        touched.amountLimits?.year?.startingAt
                      }
                      invalid={
                        errors.amountLimits?.year?.startingAt &&
                        touched.amountLimits?.year?.startingAt
                      }
                    >
                      <option value=""></option>
                      {Object.values(amountLimitsStartingAtValues).map(
                        (amountLimitValue) => (
                          <option
                            key={amountLimitValue}
                            value={amountLimitValue}
                          >
                            {amountLimitValue}
                          </option>
                        )
                      )}
                    </Field>
                    {errors.amountLimits?.year?.startingAt &&
                      touched.amountLimits?.year?.startingAt && (
                        <FormFeedback>
                          {errors.amountLimits?.year?.startingAt}
                        </FormFeedback>
                      )}
                  </FormGroup>
                </Col>
              </Row>
            )}
            <Row>
              {this.validateIfCheckboxesAreChecked() && (
                <div className="text-danger">
                  <p>
                    {" "}
                    At least one of day, week, fortnight, half year, year should
                    be checked{" "}
                  </p>
                </div>
              )}
            </Row>
          </Col>
          <Col xs={12} md={6}>
            <h4>Destination</h4>
            <Row>
              <Col xs={12}>
                <FormGroup>
                  <Label
                    htmlFor={
                      this.props.prependPath + ".paymentDetails.creditor.name"
                    }
                  >
                    Name
                  </Label>
                  <Input
                    name={
                      this.props.prependPath + ".paymentDetails.creditor.name"
                    }
                    placeholder="John Doe"
                    required
                    tag={Field}
                    validate={this.validateField(
                      "paymentDetails.creditor.name",
                      values
                    )}
                    valid={
                      !errors.paymentDetails?.creditor?.name &&
                      touched.paymentDetails?.creditor?.name
                    }
                    invalid={
                      errors.paymentDetails?.creditor?.name &&
                      touched.paymentDetails?.creditor?.name
                    }
                  />
                  {errors.paymentDetails?.creditor?.name &&
                    touched.paymentDetails?.creditor?.name && (
                      <FormFeedback>
                        {errors.paymentDetails?.creditor?.name}
                      </FormFeedback>
                    )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <FormGroup>
                  <Label
                    htmlFor={
                      this.props.prependPath +
                      ".paymentDetails.creditor.sortCode"
                    }
                  >
                    Sort Code
                  </Label>
                  <Input
                    name={
                      this.props.prependPath +
                      ".paymentDetails.creditor.sortCode"
                    }
                    pattern="^\d{2}-?\d{2}-?\d{2}$"
                    placeholder="010101"
                    required
                    tag={Field}
                    validate={this.validateField(
                      "paymentDetails.creditor.sortCode",
                      values
                    )}
                    valid={
                      !errors.paymentDetails?.creditor?.sortCode &&
                      touched.paymentDetails?.creditor?.sortCode
                    }
                    invalid={
                      errors.paymentDetails?.creditor?.sortCode &&
                      touched.paymentDetails?.creditor?.sortCode
                    }
                  />
                  {errors.paymentDetails?.creditor?.sortCode &&
                    touched.paymentDetails?.creditor?.sortCode && (
                      <FormFeedback>
                        {errors.paymentDetails?.creditor?.sortCode}
                      </FormFeedback>
                    )}
                </FormGroup>
              </Col>
              <Col xs={6}>
                <FormGroup>
                  <Label
                    htmlFor={
                      this.props.prependPath +
                      ".paymentDetails.creditor.accountNumber"
                    }
                  >
                    Account Number
                  </Label>
                  <Input
                    name={
                      this.props.prependPath +
                      ".paymentDetails.creditor.accountNumber"
                    }
                    pattern="^\d{8}$"
                    placeholder="01010101"
                    required
                    tag={Field}
                    validate={this.validateField(
                      "paymentDetails.creditor.accountNumber",
                      values
                    )}
                    valid={
                      !errors.paymentDetails?.creditor?.accountNumber &&
                      touched.paymentDetails?.creditor?.accountNumber
                    }
                    invalid={
                      errors.paymentDetails?.creditor?.accountNumber &&
                      touched.paymentDetails?.creditor?.accountNumber
                    }
                  />
                  {errors.paymentDetails?.creditor?.accountNumber &&
                    touched.paymentDetails?.creditor?.accountNumber && (
                      <FormFeedback>
                        {errors.paymentDetails?.creditor?.accountNumber}
                      </FormFeedback>
                    )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <h4>Source</h4>
            </Row>
            <Row>
              <Col xs={12}>
                <FormGroup>
                  <Label
                    htmlFor={
                      this.props.prependPath + ".paymentDetails.debtor.name"
                    }
                  >
                    Name
                  </Label>
                  <Input
                    name={
                      this.props.prependPath + ".paymentDetails.debtor.name"
                    }
                    placeholder="John Doe"
                    tag={Field}
                    validate={this.validateField(
                      "paymentDetails.debtor.name",
                      values
                    )}
                    valid={!errors.debtor?.name && touched.debtor?.name}
                    invalid={errors.debtor?.name && touched.debtor?.name}
                  />
                  {errors.debtor?.name && touched.debtor?.name && (
                    <FormFeedback>{errors.debtor?.name}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col xs={6}>
                <FormGroup>
                  <Label
                    htmlFor={
                      this.props.prependPath + ".paymentDetails.debtor.sortCode"
                    }
                  >
                    Sort Code
                  </Label>
                  <Input
                    name={
                      this.props.prependPath + ".paymentDetails.debtor.sortCode"
                    }
                    pattern="^\d{2}-?\d{2}-?\d{2}$"
                    placeholder="010101"
                    tag={Field}
                    validate={this.validateField(
                      "paymentDetails.debtor.sortCode",
                      values
                    )}
                    valid={
                      !errors.paymentDetails?.debtor?.sortCode &&
                      touched.paymentDetails?.debtor?.sortCode
                    }
                    invalid={
                      errors.paymentDetails?.debtor?.sortCode &&
                      touched.paymentDetails?.debtor?.sortCode
                    }
                  />
                  {errors.paymentDetails?.debtor?.sortCode &&
                    touched.paymentDetails?.debtor?.sortCode && (
                      <FormFeedback>
                        {errors.paymentDetails?.debtor?.sortCode}
                      </FormFeedback>
                    )}
                </FormGroup>
              </Col>
              <Col xs={6}>
                <FormGroup>
                  <Label
                    htmlFor={
                      this.props.prependPath +
                      ".paymentDetails.debtor.accountNumber"
                    }
                  >
                    Account Number
                  </Label>
                  <Input
                    name={
                      this.props.prependPath +
                      ".paymentDetails.debtor.accountNumber"
                    }
                    pattern="^\d{8}$"
                    placeholder="01010101"
                    tag={Field}
                    validate={this.validateField(
                      "paymentDetails.debtor.accountNumber",
                      values
                    )}
                    valid={
                      !errors.paymentDetails?.debtor?.accountNumber &&
                      touched.paymentDetails?.debtor?.accountNumber
                    }
                    invalid={
                      errors.paymentDetails?.debtor?.accountNumber &&
                      touched.paymentDetails?.debtor?.accountNumber
                    }
                  />
                  {errors.paymentDetails?.debtor?.accountNumber &&
                    touched.paymentDetails?.debtor?.accountNumber && (
                      <FormFeedback>
                        {errors.paymentDetails?.debtor?.accountNumber}
                      </FormFeedback>
                    )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <h4>UK Open Banking Risk</h4>
            </Row>
            <Row>
              <Col xs={12}>
                <FormGroup>
                  <Label
                    htmlFor={
                      this.props.prependPath +
                      ".consentContext.ukOpenBanking.risk.paymentContextCode"
                    }
                  >
                    Payment Context
                  </Label>
                  <Field
                    name={
                      this.props.prependPath +
                      ".consentContext.ukOpenBanking.risk.paymentContextCode"
                    }
                    as={this.props.CustomSelectComponent}
                  >
                    <option value=""></option>
                    {Object.values(ukopenBankinkRiskValues).map(
                      (openBankingRiskValue) => (
                        <option
                          key={openBankingRiskValue}
                          value={openBankingRiskValue}
                        >
                          {openBankingRiskValue}
                        </option>
                      )
                    )}
                  </Field>
                </FormGroup>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
}
